import React from "react";
import StyledInput from "../../../styles/styledInput";

interface CustomInputProps {
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    width?: string;
    height?: string;
    placeholderFontSize?: string;
    className?: string;
}

/**
 * CustomInput - matches CustomSelect structure & props
 */
const CustomInput: React.FC<CustomInputProps> = ({
    placeholder,
    value,
    onChange,
    width,
    height,
    placeholderFontSize,
    className,
    ...rest
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e.target.value);
    };

    return (
        <StyledInput
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            width={width}
            height={height}
            placeholderFontSize={placeholderFontSize}
            className={className}
            {...rest}
        />
    );
};

export default CustomInput;
